export default __webpack_public_path__ + "static/media/IMG_0058_4_11zon.6f53e66a.jpg";